/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ManaIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACVUlEQVR4nK1VuWsUYRSfKHiChY0StFFEsNUihQcoC0My75iFb97bREgnKN6WKTaFiJpEURTRTrAyQRDsbMRgIR6NoCL+CSp4BBU1ypv9djfuzowbmQ8ezPF7v9+75k0Q9HiA9RGy/k6NZDYo+2CT3FtpxLAw8k4rIxMkmc0TANaHpWSBHWUprUzOuaXAQnkC9s4w/xc1JruR5FWLjORX851dt5/rSyLZtShyYDkIpD99I98A6XFE7W+Laz+ingDSt17oB7Ac6C3yOFFknTcD0tPOuWV52DAMlyPrWS8yD6xJIXkcj2wA1k+pQ6xHe86Y9FRDRD4uzDQDKDc8cKaDYApZJgtFWO76Xl3LBFQq+1cjyxdLdaha29J8jiyT1tSG6VSeAKLb5sv6OYqiVd0RxFrxETz+y5HbAsg6UZQFkj5LOWLdm5XiYV+eq12OrBOdJXLOrY1I9jEPb6/X60s87rpxRFQ71K3OMubH8kxRlEEQ9CHLSSD93rmTkOWcD3IsS+CY3y8304xIzwPJOMTJQBiOrHHOrYy4thNI7mXspNfe55b/+I7k94DleQMsl3K3aJfJRd+DF7k92DM6uiKdY3NA3UEkG20i/kVu302KjZOB5r1xZRYXSK540H1bYkQ1QNZvBf+Dr4YxLJI88Nlczu3eoHPrgfS9J7CR7LMpAZZpYHkCLE+92fW0ZWoYYLngR/wdgK4rHBGi2mBr0bHMDFWHN+VhmWUzsNxpLbxYw0LyVqlYqsg613uTdQ5R457ImwfRbU3LwPIht8FWTtLbhl0UeZnnD06erKbyJX+jAAAAAElFTkSuQmCC)
 */
export const ManaIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M10.46 10.32v.03a2 2 0 0 0 1.19 1.18l.03.01c.43.16.43.76 0 .92h-.03a2 2 0 0 0-1.18 1.19l-.01.03a.49.49 0 0 1-.92 0v-.03a2 2 0 0 0-1.19-1.18l-.03-.01a.49.49 0 0 1 0-.92h.03a2 2 0 0 0 1.18-1.19l.01-.03a.49.49 0 0 1 .92 0ZM17.97 14.96a6 6 0 0 1-2.83 4.5c-.4.23-.85.32-1.31.32h-3.66c-.46 0-.92-.09-1.31-.33a6.01 6.01 0 0 1-2.69-3.68c-.08-.35.26-.64.6-.52l1.45.49a5 5 0 0 0 1.6.26h.36a4.4 4.4 0 0 0 3.1-1.29 3.52 3.52 0 0 1 3.93-.72l.22.1c.35.15.58.5.54.87Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M11 0a1 1 0 0 0-1 1v1H9a1 1 0 0 0 0 2v1.48a9.5 9.5 0 0 0-6.5 9.02 9.27 9.27 0 0 0 4.53 7.98c.62.38 1.35.52 2.08.52h5.78c.73 0 1.46-.14 2.08-.52a9.27 9.27 0 0 0 4.53-7.98A9.5 9.5 0 0 0 15 5.48V4a1 1 0 0 0 1-1 1 1 0 0 0-1-1h-1V1a1 1 0 0 0-1-1h-2Zm0 4v2.93l-1.37.45A7.5 7.5 0 0 0 4.5 14.5c0 2.68 1.4 4.96 3.57 6.27A2 2 0 0 0 9.1 21h5.78a2 2 0 0 0 1.04-.23 7.27 7.27 0 0 0 3.57-6.27 7.5 7.5 0 0 0-5.13-7.12L13 6.93V4h-2Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
